import { all, call, put, takeLatest } from 'redux-saga/effects'

import axios from 'portal/utils/axios-msal'
import {
  USERS_ACCOUNT_MAPPING_LOAD,
  usersAccountMappingLoaded,
  usersAccountMappingLoadFailure
} from './actions'

function* loadUsersAccountMappingSaga(action) {
  const { userIds } = action

  // Load account mappings for all users in parallel
  yield all(
    userIds.map(userId =>
      call(function* () {
        try {
          const response = yield call(() =>
            axios.get(`/users/${userId}/account-mappings`, {
              validateStatus: status => status === 200
            })
          )

          const userDetails = [...response.data]

          yield put(usersAccountMappingLoaded(userId, userDetails))
        } catch (error) {
          console.error(
            `Failed to load account mappings for user ${userId}:`,
            error
          )
          yield put(usersAccountMappingLoadFailure(userId, error))
        }
      })
    )
  )
}

export function* watch() {
  yield all([
    takeLatest(USERS_ACCOUNT_MAPPING_LOAD, loadUsersAccountMappingSaga)
  ])
}
